export default function Fraction({ num, den, size = 'md' }) {
  return (
    <span className={`fraction fraction-${size}`}>
      <span className="fraction-num">{num}</span>
      <span className="fraction-bar" />
      <span className="fraction-den">{den}</span>
    </span>
  );
}
